<template>
  <SidenavList :items="tree" />
</template>
<script>
import SidenavList from './SidenavList';

export default {
  props: {
    tree: Array
  },
  components: {
    SidenavList
  }
};
</script>

<style>
.expand-enter-active,
.expand-leave-active {
  transition-property: opacity, height;
}
.expand-enter,
.expand-leave-to {
  opacity: 0;
}
</style>
